import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  dialog: {
    height: '80vh',
    width: '140vw',
    [theme.breakpoints.down('xs')]: {
      height: '95vh',
    },
  },
  dialogContent: {
    paddingTop: 0,
    overflow: 'hidden',
    display: 'flex',
    width: '100%',
  },
  dialogContentText: {
    width: '100%',
  },
  dialogActions: {
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  search: {
    position: 'sticky',
    top: 0,
    zIndex: 99,
    marginBottom: 4,
  },
}));
